import { render, staticRenderFns } from "./airtime.vue?vue&type=template&id=472c1748&scoped=true&"
import script from "./airtime.vue?vue&type=script&lang=js&"
export * from "./airtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c1748",
  null
  
)

export default component.exports